import * as z from 'zod';
import { validationMessagesMap } from 'src/utils/messages';

export type FinancialDocumentRowFormSchemaValues = z.infer<typeof financialDocumentRowFormSchema>;
export const financialDocumentRowFormSchema = z.object({
    number: z.number().int().min(1, { message: validationMessagesMap.validationErrorMinValue }),
    name: z.string().nonempty(),
    quantity: z.number().int().min(1, { message: validationMessagesMap.validationErrorMinValue }),
    tax_percent: z
        .string()
        .regex(/^-?\d{0,20}(?:\.\d{0,4})?$/)
        .optional()
        .nullable(),
    price: z.number().int().min(0),
    price_with_tax: z.number().int().min(0).optional().nullable(),
    tax_reason: z.string(),
    unit: z.string().nonempty(),
    accounting_heading: z.string(),
});
